import { updateCoverageArea, checkCoverageArea, updateShipmentAddress } from "./shippingCTUtils";
import { getPostalCodeFromLocation } from "../addressBook/addressUtil";
import { displayServiceError, hideServiceError } from "../components/serviceError";
import { appendPostalOnFocus } from "../utilities/globalUtilities";
import { appendToUrl } from "../search/urlUtils";
import { defineHTMLForSelectedBilling } from "./checkoutTemplates";
var formValidation = require("../components/formValidation");

const mqueryRespond = window.mqRespond;
const isMobile = mqueryRespond && "status.mobile" in mqueryRespond && mqueryRespond.status.mobile;

const $cache = {
    shippingCoverageModal: $("#shipping-coverage-area-modal"),
    shippingNewAddresModal: $("#shipping-new-address-modal"),
    shippingChangeAddresModal: $("#shipping-address-modal"),
    shippingConfirmCoverageModal: $("#shipping-confirm-coverage-area-modal")
};

/**
 * Submit New Address form Handler
 */
const submitAddress = () => {
    const $shippingNewAddresForm = $(".address-form");

    $shippingNewAddresForm.on("submit", e => {
        e.preventDefault();

        const jsStepActive = $(".js-step-active");
        const activeStep = isMobile ? jsStepActive.closest(".shipping-section").find(".step-type--address") : jsStepActive;
        let isPrimaryShipment = activeStep.attr("data-is-primary") == "true" ? true : false;
        const $form = $(".address-form");
        const $postalCode = $form.find("#zipCode");
        const postalCode = $postalCode.val();
        const targetParams = {
            selectedPostal: postalCode
        };

        let callbackResult;
        checkCoverageArea(targetParams, result => {
            callbackResult = result;
        });

        if (callbackResult && (callbackResult.error || !callbackResult.data.storeId)) {
            $(".shipping-coverage-area-modal--body").addClass("js-closed-for-confirmation");
            // Show Confirm modal and set where it was triggered from
            $cache.shippingConfirmCoverageModal.find(".modal-body").data("triggered-by", "new-address");
            $cache.shippingConfirmCoverageModal.modal("show");

            // Hide current modal
            if (window.mqRespond.status.mobile) {
                $cache.shippingCoverageModal.modal("hide");
            } else {
                $cache.shippingNewAddresModal.modal("hide");
            }
            return;
        }

        if (!isPrimaryShipment) {
            $.spinner().start();
            submitAddressRequest(true);
            return;
        }

        // Show Confirm modal and set where it was triggered from
        $(".shipping-coverage-area-modal--body").addClass("js-closed-for-confirmation");
        $cache.shippingConfirmCoverageModal.find(".modal-body").data("triggered-by", "new-address");
        $cache.shippingConfirmCoverageModal.modal("show");

        // Hide modals
        $cache.shippingCoverageModal.modal("hide");
        $cache.shippingChangeAddresModal.modal("hide");
        $cache.shippingNewAddresModal.modal("hide");
    });
};

/**
 * Submit New Address form call
 * @param {Boolean} sameCoverageArea - if new address is created in the same coverage area
 */
const submitAddressRequest = sameCoverageArea => {
    const $form = $(".address-form");
    const url = $form.attr("action");
    const serviceErrorContainer = document.querySelector(".address-form .ct-service-error-container");
    const urlParams = {};
    
    $form.trigger("address:submit");
    hideServiceError(serviceErrorContainer);
    urlParams.isCheckout = true;
    $.ajax({
        url: appendToUrl(url, urlParams),
        type: "POST",
        dataType: "json",
        data: $form.serialize(),
        success: data => {
            if (!data.success) {
                formValidation($form, data);
                if (data && data.addressLimitExceeded) {
                    $.spinner().stop();
                    $("#shipping-new-address-modal, #shipping-coverage-area-modal").modal("hide");
                    const $addressesLimitModal = $("#addresses-limit-exceeded-modal");
                    $addressesLimitModal.modal("show");
                    if (data.message) {
                        $addressesLimitModal.find(".js-address-limit-msg").text(data.message);
                    }
                    $cache.shippingConfirmCoverageModal.modal("hide");
                    return;
                }
                displayServiceError(serviceErrorContainer, data.message);

                // Show current modal
                if (window.mqRespond.status.mobile) {
                    $cache.shippingCoverageModal.modal("show");
                } else {
                    $cache.shippingNewAddresModal.modal("show");
                }

                // Hide confirmation modal
                $.spinner().stop();
                $cache.shippingConfirmCoverageModal.modal("hide");
            } else {
                // Refreshing the selected billing section with the new data when new address is added
                defineHTMLForSelectedBilling(data);

                if (sameCoverageArea) {
                    let activeStep = $(".js-step-active");
                    const $coverageModal = $("#shipping-coverage-area-modal");

                    if ($coverageModal.is(":visible")) {
                        const $coverageAreaModalForm = $coverageModal.find(".js-coverage-area-form");
                        const shipmentId = $coverageAreaModalForm.data("shipment-id");
                        activeStep = $(`.step-type--address[data-shipment-id="${shipmentId}"]`);
                    }

                    const params = {
                        addressId: data.addressId,
                        isHome: true,
                        addNewAddress: true
                    };
        
                    updateShipmentAddress(params, activeStep);
                    $.spinner().stop();
                    return;
                }

                const $targetElement = $("#zipCode");
                const selectedPostal = $targetElement.val();

                const targetParams = {
                    selectedPostal: selectedPostal,
                    newAddress: true,
                    selectedAddressId: data.addressId,
                    selectedDeliveryLocation: data.addressPostalCode
                };

                // update Coverage Area
                updateCoverageArea(targetParams);
            }
        },
        error: function (err) {
            $.spinner().stop();
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
        },
        complete: () => {
            $.spinner().stop();
        }
    });
};

/**
 * Init Shipping New Address events
 */
const shippingNewAddressEvents = () => {
    getPostalCodeFromLocation();
    submitAddress();
    appendPostalOnFocus();
};

export { shippingNewAddressEvents, submitAddressRequest };
